import { render } from "./FileDisplay.vue?vue&type=template&id=addac6ac&scoped=true"
import script from "./FileDisplay.vue?vue&type=script&lang=js"
export * from "./FileDisplay.vue?vue&type=script&lang=js"

import "./FileDisplay.vue?vue&type=style&index=0&id=addac6ac&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-addac6ac"]])

export default __exports__